/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Pricing_PublicInputs */

const en_admin_resource_form_pricing_public = /** @type {(inputs: Admin_Resource_Form_Pricing_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing (public)`)
};

const de_admin_resource_form_pricing_public = /** @type {(inputs: Admin_Resource_Form_Pricing_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis für öffentliche Ressource`)
};

const es_admin_resource_form_pricing_public = /** @type {(inputs: Admin_Resource_Form_Pricing_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio para recurso público`)
};

const fr_admin_resource_form_pricing_public = /** @type {(inputs: Admin_Resource_Form_Pricing_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix pour ressource publique`)
};

/** @type {(inputs: Admin_Resource_Form_Pricing_PublicInputs) => LocalizedString} */
const it_admin_resource_form_pricing_public = en_admin_resource_form_pricing_public;

/** @type {(inputs: Admin_Resource_Form_Pricing_PublicInputs) => LocalizedString} */
const pt_br2_admin_resource_form_pricing_public = en_admin_resource_form_pricing_public;

/** @type {(inputs: Admin_Resource_Form_Pricing_PublicInputs) => LocalizedString} */
const pl_admin_resource_form_pricing_public = en_admin_resource_form_pricing_public;

/** @type {(inputs: Admin_Resource_Form_Pricing_PublicInputs) => LocalizedString} */
const hu_admin_resource_form_pricing_public = en_admin_resource_form_pricing_public;

/** @type {(inputs: Admin_Resource_Form_Pricing_PublicInputs) => LocalizedString} */
const ro_admin_resource_form_pricing_public = en_admin_resource_form_pricing_public;

/**
* | output |
* | --- |
* | "Pricing (public)" |
*
* @param {Admin_Resource_Form_Pricing_PublicInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_pricing_public = /** @type {((inputs?: Admin_Resource_Form_Pricing_PublicInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Pricing_PublicInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_pricing_public(inputs)
	if (locale === "de") return de_admin_resource_form_pricing_public(inputs)
	if (locale === "es") return es_admin_resource_form_pricing_public(inputs)
	if (locale === "fr") return fr_admin_resource_form_pricing_public(inputs)
	if (locale === "it") return it_admin_resource_form_pricing_public(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_pricing_public(inputs)
	if (locale === "pl") return pl_admin_resource_form_pricing_public(inputs)
	if (locale === "hu") return hu_admin_resource_form_pricing_public(inputs)
	return ro_admin_resource_form_pricing_public(inputs)
});
export { admin_resource_form_pricing_public as "admin.resource_form.pricing_public" }